import React, { useRef, useState } from 'react';
// import { connect } from 'react-redux';
import Select from 'react-select';

import ENUMS from '../../enums/index';
import { permissionHelper } from '../../utils';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';

import '../payments/payments.scss';

const { CONFIRM_OR_REJECT_COMMENT, SEARCH_CAFE_NAMES } = ENUMS.PERMISSIONS.values;

const CommentsFilter = props => {
  let formRefrence = useRef();

  let [startDate, setStartDate] = useState(' ');
  let [confimredComment, setConfirmedComment] = useState(false);
  let [notConfimredComment, setNotConfirmedComment] = useState(false);
  let [waitingComment, setWaitingComment] = useState(false);
  let [endDate, setEndDate] = useState(' ');
  let [cafeName, setCafeName] = useState();
  let [userFullName, setUserFullName] = useState('');
  let [selectedResponsesType, setSelectedResponsesType] = useState([]);
  let [selectedResponsesPermission, setSelectedResponsesPermission] = useState('');
  const [cafeType, setCafeType] = useState('')

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setUserFullName('');
    setConfirmedComment(false);
    setNotConfirmedComment(false);
    setWaitingComment(false);
    setCafeName('');
    setSelectedResponsesType('');
    setSelectedResponsesPermission('');
    setStartDate(' ');
    setEndDate(' ');
    setCafeType('');
    props.applyFilters(event);
  };

  const onChangeIsConfimredComment = e => {
    setConfirmedComment(e.target.checked);
  };

  const onChangeIsNotConfimredComment = e => {
    setNotConfirmedComment(e.target.checked);
  };

  const onChangeWaitingComment = e => {
    setWaitingComment(e.target.checked);
  };

  return (
    <article className="card card my-4">
      <header className="text-center card-header">
        <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
      </header>
      <main className="card-body">
        <form
          ref={formRefrence}
          onReset={event => resetForm(event)}
          onSubmit={event => {
            props.applyFilters(event);
          }}
          id="filterForm"
        >
          <div className="col-12 justify-content-around p-0 align-items-center">
            <div className="col-12 d-flex row flex-sm-column col-12 flex-md-row justify-content-between py-3">
              <div className="col-sm-12 col-md-4">
                <label htmlFor="userFullNamePart" className="col-12 p-0 text-right filter-field-label">
                  {locales('fields.comment.sender.name')}
                </label>
                <input
                  onChange={event => setUserFullName(event.target.value)}
                  value={userFullName || ''}
                  id="userFullNamePart"
                  name="userFullNamePart"
                  type="text"
                  className="form-control col-12"
                  placeholder={locales('fields.comment.sender.name')}
                  maxLength={ENUMS.MAX_LENGTH.fullName}
                />
                <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
              </div>
              <div className="col-sm-12 col-md-8">
                <span className="col-6 text-right filter-field-label">{locales('tables.creationDate')}</span>
                <div className="d-flex col-12 justify-content-around py-2 align-items-center">
                  از
                  <DatePicker
                    marge={true}
                    name="startDate"
                    onChange={value => setStartDate(value)}
                    value={startDate}
                    className="form-control"
                    placeholder={locales('fields.startDate')}
                  />
                  تا
                  <DatePicker
                    marge={true}
                    name="endDate"
                    onChange={value => setEndDate(value)}
                    value={endDate}
                    className="form-control"
                    placeholder={locales('fields.endDate')}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 d-flex row flex-sm-column col-12 flex-md-row justify-content-between py-3">
              <div className="col-sm-12 col-12 col-md-4">
                <label htmlFor="isCafeAllowedToRespond" className="col-12 text-right filter-field-label">
                  {locales('titles.responsesPermission')}
                </label>
                <Select
                  placeholder={`${locales('titles.responsesPermission')}...`}
                  name="isCafeAllowedToRespond"
                  id="isCafeAllowedToRespond"
                  value={selectedResponsesPermission}
                  options={ENUMS.COMMENTS_RESPONSES_PERMISSION.list.map(permName => ({
                    label: permName.title,
                    value: permName.value
                  }))}
                  onChange={selectedResponsesPerm => setSelectedResponsesPermission(selectedResponsesPerm)}
                  className="col-12"
                />
              </div>
              <div className="col-sm-12 col-12 col-md-4">
                <label htmlFor="responseType" className="col-12 text-right filter-field-label">
                  {locales('titles.responses')}
                </label>
                <Select
                  placeholder={`${locales('titles.responses')}...`}
                  isMulti={true}
                  name="responseType"
                  id="responseType"
                  value={selectedResponsesType}
                  options={ENUMS.COMMENTS_RESPONSES_TYPE.list.map(bankName => ({
                    label: bankName.title,
                    value: bankName.value
                  }))}
                  onChange={selectedResponses => setSelectedResponsesType(selectedResponses)}
                  className="col-12"
                />
              </div>
              <div className="col-sm-12 col-12 col-md-4">
                <label
                  className="col-12 text-right filter-field-label"
                  htmlFor="cafeType"
                >
                  {locales('cafes.type')}
                </label>
                <div className="full-width">
                  <Select
                    placeholder={locales('messages.select.cafes.type')}
                    isMulti={false}
                    value={cafeType}
                    id="cafeType"
                    name="cafeType"
                    options={ENUMS.CAFE_TYPE.list?.map(type => ({
                      value: type.value,
                      label: type.title,
                    }))}
                    onChange={selected =>
                      setCafeType(selected)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 d-flex row flex-sm-column col-12 flex-md-row justify-content-between py-3">
            {permissionHelper.hasUserPermission(SEARCH_CAFE_NAMES) && (
              <div className="col-sm-12 col-md-4">
                <label htmlFor="cafeNamePart" className="col-12 p-0 text-right filter-field-label">
                  {locales('fields.cafe.name')}
                </label>
                <input
                  onChange={event => setCafeName(event.target.value)}
                  value={cafeName || ''}
                  name="cafeNamePart"
                  id="cafeNamePart"
                  type="text"
                  className="form-control col-12"
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                />
                <small style={{ color: '#ccc' }}>{locales('maxLength.30')}</small>
              </div>
            )}
            {permissionHelper.hasUserPermission(CONFIRM_OR_REJECT_COMMENT) && (
              <div className="col-sm-12 col-md-8">
                <label className="col-12 text-right filter-field-label">{locales('tables.status')}</label>
                <div className="form-group">
                  <div className="form-check-inline">
                    <label className="form-check">
                      <input
                        value="CONFIRMED"
                        name="status"
                        checked={confimredComment}
                        onChange={onChangeIsConfimredComment}
                        className="form-check-input"
                        type="checkbox"
                      />
                      {locales('tables.confirmed')}
                    </label>
                  </div>
                  <div className="form-check-inline">
                    <label className="form-check">
                      <input
                        value="REJECTED"
                        name="status"
                        checked={notConfimredComment}
                        onChange={onChangeIsNotConfimredComment}
                        className="form-check-input"
                        type="checkbox"
                      />
                      {locales('titles.rejected')}
                    </label>
                  </div>
                  <div className="form-check-inline">
                    <label className="form-check">
                      <input
                        value="WAITING"
                        name="status"
                        checked={waitingComment}
                        onChange={onChangeWaitingComment}
                        className="form-check-input"
                        type="checkbox"
                      />
                      {locales('labels.waiting')}
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-comments" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </form>
      </main>
    </article>
  );
};

// const mapStateToProps = state => {
//   return {
//     userRoleType: state.authReducer.meInfo.selectedRole.type
//   };
// };

// export default connect(mapStateToProps)(CommentsFilter);

export default CommentsFilter;
